import { useParams } from 'react-router-dom';
import { ItemListingSummary } from './ItemListingSummary';

export function ItemListingSummaryWrapper() {
    const { id } = useParams();

    return (
        <ItemListingSummary itemListingId={id} />
    );
}